import React, { useCallback, useEffect, useMemo, useState } from "react";
import axios from "axios";
import { connect } from "react-redux";
import ReportFilters from "../../../../Components/corporate/reports/ReportFilters";
import {
  companyObject,
  corporateAccountObject,
  isAgencyUser,
  isRoleEdgeAdmin,
  isSuperAgent,
} from "../../../../modules/permissions";
import {
  companyUnload,
  corporateDepartmentsUnload,
  fetchAgenciesForSelect,
  fetchAgency,
  fetchCompanies,
  fetchCompaniesForEvents,
  fetchCompany,
  fetchCorporateAccount,
  fetchCorporateDepartments,
  fetchHotelGroup,
  fetchPreferredProgrammeSpendReport,
  spendReportUnload,
  unloadCompanyList,
  unloadCorporateAccount,
  unloadPreferredProgrammeSpendReport,
} from "../../../../redux/actions";
import Loading from "../../../../Components/Loading";
import { isCorporate, token } from "../../../../modules/auth";
import { fetchVenuesFromHotelGroup } from "../../../../redux/actions/venues";
import html2canvas from "html2canvas";
import printJS from "print-js";
import { ButtonPrimary } from "../../../../Components/Button";
import { camelCaseToWords, listFormatter, removeEmptySearchParams } from "../../../../utils";
import * as ROUTES from "../../../../Router/corporate_routes";
import { saveData } from "../../../../services/downloadFile";
import { format } from "date-fns";
import { useHistory, useLocation } from "react-router-dom";
import PreferredProgrammeSpendReportTable
  from "../../../../Components/corporate/reports/PreferredProgrammeSpendReportTable";
import PreferredProgrammeSpendReportCharts
  from "../../../../Components/corporate/reports/PreferredProgrammeSpendReportCharts";

const PreferredProgrammeSpendReportContainer = ({
                                                  corporateAccount,
                                                  preferredProgrammeSpendReport,
                                                  isLoadingSpendReport,
                                                  token,
                                                  fetchPreferredProgrammeSpendReport,
                                                  spendReportUnload,
                                                  fetchVenuesFromHotelGroup,
                                                  venues,
                                                  companies,
                                                  isAgency,
                                                  isSuperAgent,
                                                  fetchCompaniesForEvents,
                                                  unloadCompanyList,
                                                  corporateDepartments = [],
                                                  fetchCorporateDepartments,
                                                  companyObject,
                                                  unloadCorporateAccount,
                                                  corporateDepartmentsUnload,
                                                  fetchCorporateAccount,
                                                  errorData,
                                                  selectedAgencies,
                                                  isFetchingCompany,
                                                  isRoleEdgeAdmin,
                                                  fetchAgenciesForSelect,
                                                  agenciesForSelect,
                                                  fetchCompanies,
                                                  isCorporate,
                                                  fetchHotelGroup,
                                                  hotelGroup,
                                                  fetchAgency,
                                                  fetchCompany,
                                                  agency,
                                                  unloadPreferredProgrammeSpendReport,
                                                }) => {
  const [company, setCompany] = useState(companyObject);
  const [companyUsers, setCompanyUsers] = useState([]);
  const [queryParams, setQueryParams] = useState({});
  const [hasSearched, setHasSearched] = useState(false);
  const [showPdfContainer, setShowPdfContainer] = useState(false);
  const [selectedAgency, setSelectedAgency] = useState();
  const [countryName, setCountryName] = useState();
  const location = useLocation();
  const history = useHistory();
  const searchParams = new URLSearchParams(location.search);
  const preferredProgramme = searchParams.get("preferredProgramme");
  const agencyId = searchParams.get("agencyId");
  const companyId = searchParams.get("companyId");

  useEffect(() => {
    return () => unloadPreferredProgrammeSpendReport();
  }, []);

  useEffect(() => {
    fetchHotelGroup(preferredProgramme, token);
    if (agencyId) {
      fetchAgency(agencyId, token);
    }
    if (companyId) {
      fetchCompany(companyId, token, { minimal: true });
    }
  }, [preferredProgramme, agencyId, companyId]);

  useEffect(() => {
    if (preferredProgramme) {
    } else {
      history.push({
        pathname: ROUTES.FRONTEND.AGENCY.REPORTS.PREFERRED_PROGRAMME_SPEND_SELECTOR.replace(
          "agency/",
          "",
        ),
      });
    }
  }, [location]);

  const logo = corporateAccount?.logo_link
    ? corporateAccount?.logo_link
      ? corporateAccount?.cdn_path
      : "/img/CE-logo-alt.png"
    : "/img/logo.png";
  const logoAlt = corporateAccount?.logo_link
    ? corporateAccount.account_name + " logo"
    : "EDGE Venues logo";

  useEffect(() => {
    if (isAgency) {
      fetchCompaniesForEvents(token);
    }
    return () => {
      spendReportUnload();
      unloadCompanyList();
    };
  }, [selectedAgencies]);

  useEffect(() => {
    if (isRoleEdgeAdmin) {
      fetchAgenciesForSelect(token, true);
    }
  }, []);

  useEffect(() => {
    if (isRoleEdgeAdmin && selectedAgency) {
      fetchCompanies(token, null, { agencyId: selectedAgency }, true);
    }
    if (isRoleEdgeAdmin && !selectedAgency) {
      unloadCompanyList();
    }
  }, [isRoleEdgeAdmin, company, selectedAgency]);

  useEffect(() => {
    if (corporateAccount) {
      fetchCorporateDepartments(corporateAccount.id, token);
    }
  }, [corporateAccount]);

  useEffect(() => {
    setCompanyUsers(companyObject ? companyObject.users : []);
    setCompany(companyObject);
  }, [companyObject]);

  const runSpendReport = useCallback(
    queryFilters => {
      setHasSearched(true);
      setQueryParams(queryFilters);
      delete queryFilters.page;
      if (preferredProgramme) {
        queryFilters.preferredProgramme = preferredProgramme;
      }
      if (agencyId) {
        queryFilters.agency = agencyId;
      }
      if (companyId) {
        queryFilters.company = companyId;
      }
      return fetchPreferredProgrammeSpendReport(token, queryFilters);
    },
    [company, fetchPreferredProgrammeSpendReport, token, agencyId, companyId],
  );

  const resetSpendReport = useCallback(() => {
    setSelectedAgency("");
    spendReportUnload();
    unloadCorporateAccount();
    corporateDepartmentsUnload();
    setHasSearched(false);
  }, [spendReportUnload, unloadCorporateAccount, corporateDepartmentsUnload]);

  const getVenuesForHotelGroup = group => {
    return fetchVenuesFromHotelGroup(group, token);
  };

  const savePdf = useCallback(() => {
    setShowPdfContainer(true);
    const domElement = document.getElementById("pdfContainer");
    const filtersSummary = document.getElementById("filtersSummary");
    const logoContainer = document.getElementById("logo");
    html2canvas(domElement).then(canvas => {
      const img = canvas.toDataURL();
      printJS({
        printable: img,
        type: "image",
        base64: true,
        documentTitle: "EDGE Venues",
        onPrintDialogClose: () => {
          logoContainer.classList.add("hidden");
          filtersSummary.classList.add("hidden");
        },
      });
    });
    if (
      !filtersSummary.classList.contains("hidden") ||
      !logoContainer.classList.contains("hidden")
    ) {
      logoContainer.classList.add("hidden");
    }
  }, []);

  const getCompany = useCallback(
    companyId => {
      companyUnload();
      return fetchCompany(companyId, token);
    },
    [token, fetchCompany, companyUnload],
  );

  const getCorporateAccount = useCallback(
    corporateAccountId => {
      if (corporateAccountId) {
        fetchCorporateAccount(corporateAccountId, token);
        fetchCorporateDepartments(corporateAccountId, token);
      } else {
        unloadCorporateAccount();
        corporateDepartmentsUnload();
      }
    },
    [
      fetchCorporateAccount,
      fetchCorporateDepartments,
      token,
      unloadCorporateAccount,
      corporateDepartmentsUnload,
    ],
  );

  const getReportFiltersSummary = useMemo(() => {
    return (
      <div className="border rounded p-4 bg-gray-100 mb-4 w-full max-w-2xl">
        <h2 className="font-bold text-lg mb-2">
          Preferred spend for {agency?.name ?? company?.name ?? hotelGroup?.name ?? ""}
        </h2>
        {Object.entries(queryParams).map(([key, value], index) => {
          if (key === "agency" || key === "company") {
            return;
          }
          if (key === "department") {
            const departmentsArray = corporateDepartments
              ?.filter(dept => value?.includes(dept.id))
              .map(dept => dept.name);
            return departmentsArray.length ? (
              <div key={index} className="mb-1">
                <span className="font-bold">Departments:</span>{" "}
                {listFormatter.format(departmentsArray)}
              </div>
            ) : null;
          }
          if (key === "company") {
            const companiesArray = Array.isArray(companies)
              ? companies
                .filter(com => {
                  return typeof value === "object"
                    ? value?.includes(com.id)
                    : value == com.id;
                })
                .map(com => com.name)
              : [];
            return companiesArray?.length ? (
              <div key={index} className="mb-1">
                <span className="font-bold">Companies:</span>{" "}
                {listFormatter.format(companiesArray)}
              </div>
            ) : null;
          }
          if (key === "dateRange") {
            const [dateFrom, dateTo] = value.split(",");
            return (
              <div key={index} className="mb-1">
                <div>
                  <span className="font-bold">Date From:</span>{" "}
                  {format(new Date(dateFrom), "DD/MM/YYYY")}
                </div>
                <div>
                  <span className="font-bold">Date To:</span>{" "}
                  {format(new Date(dateTo), "DD/MM/YYYY")}
                </div>
              </div>
            );
          }
          if (key === "preferredProgramme") {
            if (hotelGroup) {
              return <div className="mb-1">
                <span className="font-bold">Preferred Programme:</span>{" "}
                {hotelGroup.name}
              </div>;
            }
            return;
          }
          if (key === "country") {
            return countryName ? (
              <div key={index} className="mb-1">
                <span className="font-bold">{camelCaseToWords(key)}:</span>{" "}
                {countryName}
              </div>
            ) : null;
          } else {
            return value ? (
              <div key={index} className="mb-1">
                <span className="font-bold">{camelCaseToWords(key)}:</span>{" "}
                {value}
              </div>
            ) : null;
          }
        })}
      </div>
    );
  }, [queryParams, corporateDepartments, companies, countryName, hotelGroup, agency, company]);

  const runSpendReportExport = async () => {
    try {
      if (queryParams.page) {
        delete queryParams.page;
      }
      let queryFilters = new URLSearchParams(queryParams);
      removeEmptySearchParams(queryFilters);
      let queryString = queryFilters.toString();
      let response = await axios.get(
        window.API +
        ROUTES.API.CORPORATE.REPORTS.SPEND_REPORT_EXPORT +
        "?" +
        queryString,
        {
          responseType: "blob",
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      saveData("csv", response.data, `spend-report.csv`);
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <div className="min-w-full">
      <h1 className="my-4">Preferred Programme Spend Report</h1>
      <ReportFilters
        shouldDisableSubmit={isFetchingCompany}
        isLoading={isFetchingCompany}
        runReport={runSpendReport}
        showExport={false}
        resetReport={resetSpendReport}
        getVenuesForHotelGroup={getVenuesForHotelGroup}
        venues={venues}
        disableAgencyFilter={true}
        showFilters={{
          hotelGroup: true,
          showCount: false,
          country: true,
          town: true,
          county: true,
          bookingAgent: true,
          accommodationFilter: true,
        }}
        corporateAccount={corporateAccount}
        corporateDepartments={corporateDepartments}
        companyUsers={companyUsers}
        // companies={companies}
        getCompany={getCompany}
        getCorporateAccount={getCorporateAccount}
        error={errorData && errorData.errors}
        advancedFilters={true}
        isMultiFilters={true}
        isSuperAgent={isSuperAgent}
        agenciesForSelect={agenciesForSelect}
        selectedAgency={selectedAgency}
        setSelectedAgency={setSelectedAgency}
        isEdgeAdmin={isRoleEdgeAdmin}
        setCountryName={setCountryName}
      />
      {isLoadingSpendReport ? <Loading /> : null}
      {!isLoadingSpendReport &&
      preferredProgrammeSpendReport &&
      Object.keys(preferredProgrammeSpendReport).length > 0 ? (
        <>
          <div id="pdfContainer">
            <div id="logo" className="hidden">
              <img
                src={logo}
                alt={logoAlt}
                style={{
                  height: "60px",
                  width: "135px;",
                  maxHeight: "60px",
                }}
              />
              <p className="mb-0 text-xs">Powered by EDGE Venues</p>
            </div>
            <div className="overflow-hidden border-b border-gray-200 bg-white p-5">
              <div className="flex-auto">
                <PreferredProgrammeSpendReportCharts report={preferredProgrammeSpendReport} />
                <hr />
                <PreferredProgrammeSpendReportTable report={preferredProgrammeSpendReport} />
              </div>
            </div>
            <div id="filtersSummary" className="pt-4">
              {getReportFiltersSummary}
            </div>
          </div>
          <div className={"row mb-2"}>
            <div className={"col flex"}>
              <ButtonPrimary classes={"mt-4 mr-2"} onClick={() => savePdf()}>
                Export to PDF
              </ButtonPrimary>
              <ButtonPrimary
                classes={"mt-4"}
                onClick={() => runSpendReportExport()}
              >
                Export to CSV
              </ButtonPrimary>
            </div>
          </div>
        </>
      ) : null}
      {!isLoadingSpendReport &&
      hasSearched &&
      preferredProgrammeSpendReport &&
      Object.keys(preferredProgrammeSpendReport).length === 0 ? (
        <div className="p-3 bg-warning text-white w-full my-6">
          <p className={"mb-0"}>
            <i className="fas text-2lg fa-info-circle mr-3" />
            There no results found, please amend the filters above and run the
            report again.
          </p>
        </div>
      ) : null}
      {!hasSearched ? (
        <div className="p-3 bg-lighter-blue w-full my-6">
          <p className={"mb-0"}>
            <i className="fas text-2lg fa-info-circle mr-3" />
            Please use the filters above and click run, to view the Spend
            Report.
          </p>
        </div>
      ) : null}
    </div>
  );
};

const mapStateToProps = state => {
  let corporateAccount =
    Object.entries(corporateAccountObject(state.auth)).length > 0
      ? corporateAccountObject(state.auth)
      : state.corporateAccount?.corporateAccount;
  let companyAccount =
    Object.entries(companyObject(state.auth)).length > 0
      ? companyObject(state.auth)
      : state.company?.company;
  let companies = state.companyList.companiesForEvents
    ? state.companyList.companiesForEvents.data
    : [];
  let isEdgeAdmin = isRoleEdgeAdmin(state.auth);
  if (isEdgeAdmin) {
    companies = state.companyList.companies ? state.companyList.companies : [];
  }
  return {
    ...state.selectedAgencies,
    ...state.company,
    ...state.agency,
    ...state.preferredProgrammeSpendReport,
    ...state.brand,
    ...state.isLoadingSpendReport,
    ...state.venues,
    ...state.corporateDepartments,
    ...state.agenciesForSelect,
    ...state.agencyList,
    ...state.hotelGroup,
    companies: companies || [],
    errorData: state.preferredProgrammeSpendReport.errorData,
    isAgency: isAgencyUser(state.auth),
    isCorporate: isCorporate(state),
    corporateAccount: corporateAccount,
    token: token(state),
    companyObject: companyAccount,
    isSuperAgent: isSuperAgent(state.auth),
    isRoleEdgeAdmin: isRoleEdgeAdmin(state.auth),
  };
};

const mapDispatchToProps = {
  fetchCompanies,
  fetchAgency,
  fetchHotelGroup,
  fetchAgenciesForSelect,
  fetchPreferredProgrammeSpendReport,
  unloadPreferredProgrammeSpendReport,
  spendReportUnload,
  fetchVenuesFromHotelGroup,
  fetchCompany,
  companyUnload,
  fetchCompaniesForEvents,
  fetchCorporateAccount,
  unloadCompanyList,
  fetchCorporateDepartments,
  unloadCorporateAccount,
  corporateDepartmentsUnload,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PreferredProgrammeSpendReportContainer);
